import { render, staticRenderFns } from "./settings-table.vue?vue&type=template&id=4ef0b524&scoped=true&"
import script from "./settings-table.js?vue&type=script&lang=js&"
export * from "./settings-table.js?vue&type=script&lang=js&"
import style0 from "./settings-table.scss?vue&type=style&index=0&id=4ef0b524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0b524",
  null
  
)

export default component.exports